import { useCallback, useEffect, useState } from "react";
import { ESTORE_CART_EVENT, readEstoreCart } from "../utils/estoreCart";

export function useEstoreCart() {
  const [lines, setLines] = useState(() => readEstoreCart());

  const refresh = useCallback(() => {
    setLines(readEstoreCart());
  }, []);

  useEffect(() => {
    const on = () => refresh();
    window.addEventListener(ESTORE_CART_EVENT, on);
    return () => window.removeEventListener(ESTORE_CART_EVENT, on);
  }, [refresh]);

  const count = lines.reduce((s, i) => s + i.qty, 0);
  const subtotal = lines.reduce((s, i) => s + i.unitPrice * i.qty, 0);

  return {
    lines,
    count,
    subtotal,
    refresh,
  };
}
